import { render, staticRenderFns } from "./view-loading.vue?vue&type=template&id=9c85dc26&scoped=true&"
import script from "./view-loading.vue?vue&type=script&lang=js&"
export * from "./view-loading.vue?vue&type=script&lang=js&"
import style0 from "./view-loading.vue?vue&type=style&index=0&id=9c85dc26&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c85dc26",
  null
  
)

export default component.exports